// JOBE-0044.13: DocumentPreview — per-kind preview for `document` rows
// (and any kind whose entity-type registers `structuralShape:
// document`, via the registry's fallback consult on
// EntityTypesContext).
//
// Renders:
//   - Header (entity name + kind badge + owner)
//   - Preview card showing `EntityRow.summary` **verbatim**. Per the
//     PR #677 review fix-up (commit c4e8850f), the preview body is
//     sourced exclusively from `EntityRow.summary`. There is NO
//     commit-message fallback to `versions[last].message` — that field
//     is the commit-log line per JOBE-0044.5's 80-char-truncation
//     treatment, not document prose. If `summary` is `null` server-
//     side (no `description`, no first paragraph of `body`), the
//     preview card renders a quiet "No summary available" line rather
//     than substituting other copy.
//   - Bottom-of-pane "Open document ↗" affordance → /library/:urn

import { useNavigate } from 'react-router-dom';
import { urnSlug } from '../../../lib/relTime.js';
import { AddToCollectionAction } from '../AddToCollectionAction.jsx';

export function DocumentPreview({ entity }) {
  const navigate = useNavigate();
  if (!entity) return null;

  const onOpen = (e) => {
    e.preventDefault();
    navigate(`/library/${encodeURIComponent(entity.urn)}`);
  };

  const ownerLabel = entity.owner?.displayName
    || entity.owner?.name
    || urnSlug(entity.owner?.urn || '')
    || null;

  return (
    <section className="library-inspector-preview library-inspector-document-preview">
      <header className="library-inspector-header">
        <h3 className="library-inspector-name">
          {entity.name || urnSlug(entity.urn) || 'Untitled'}
        </h3>
        <div className="library-inspector-meta">
          {entity.kind && (
            <span className="library-inspector-kind">{entity.kind}</span>
          )}
          {ownerLabel && (
            <span className="library-inspector-owner" title={entity.owner?.urn || ''}>
              {ownerLabel}
            </span>
          )}
        </div>
        <div className="library-inspector-urn" title={entity.urn}>{entity.urn}</div>
      </header>

      <div className="library-inspector-preview-card">
        <div className="library-inspector-preview-label">
          Preview · first paragraph
        </div>
        {entity.summary ? (
          <p className="library-inspector-preview-body">{entity.summary}</p>
        ) : (
          <p className="library-inspector-preview-body muted">
            No summary available.
          </p>
        )}
        <div className="library-inspector-preview-fade" aria-hidden="true" />
      </div>

      <div className="library-inspector-actions">
        <a
          className="library-inspector-open"
          href={`/library/${encodeURIComponent(entity.urn)}`}
          onClick={onOpen}
        >
          Open document ↗
        </a>
        <AddToCollectionAction entity={entity} />
      </div>
    </section>
  );
}
